import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import * as moment from 'moment';

export const DATE_VALUES = {
  display: {
    dateInput: 'YYYY'
  },
};

@Component({
  selector: 'insert-edit-year',
  templateUrl: './year.component.html',
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective }
  ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: DATE_VALUES },
    { provide: DateAdapter, useClass: MomentDateAdapter }
  ]
})
export class YearComponent implements OnInit {
  @Input() fieldName!: string;
  @Input() label!: string;
  @Input() required: boolean = false;

  constructor(private formGroupDirective: FormGroupDirective) { }

  ngOnInit() {
    const v = this.getFormControlField()?.value;

    if(v !== null && v !== '') {
      this.getFormControlField()?.setValue(moment(v, 'YYYY'));
    }
  }

  getFormControlField() {
    return this.formGroupDirective.form.get(this.fieldName);
  }

  clearField() {
    this.getFormControlField()?.setValue(null);
  }

  onYearSelected(year: moment.Moment, datepicker: MatDatepicker<moment.Moment>) {
    this.getFormControlField()?.setValue(year);
    datepicker.close();
  }
}
